























import Vue from 'vue'
import { storageRef, imagekit, db } from '@/firebase'
import { BlogPost } from '@/types'
import { convertDataFromApi } from '@/utils'

export default Vue.extend({
    name: 'HeadlineCarousel',
    data: () => ({
        newPosts: [] as BlogPost[],
    }),
    computed: {
        allDeckImages() {
            return this.newPosts.reduce(
                (acc: object[], post: BlogPost, ind: number) => [
                    ...acc,
                    ...(post.deckImageURLs ? post.deckImageURLs.map((url) => ({ url, postId: ind })) : []),
                ],
                []
            )
        },
        isMobile() {
            return this.$vuetify.breakpoint.mobile
        },
    },
    mounted() {
        db.collection('fl_content')
            .where('_fl_meta_.schema', '==', 'eventBlog')
            .orderBy('_fl_meta_.lastModifiedDate', 'desc')
            .limit(3) // The first 3 blogs
            .get()
            .then((snapshot) => {
                // TODO: refactor the image url retrieval to a separate module
                const postPromises = snapshot.docs.map((doc) => {
                    const rawRes = convertDataFromApi(doc.data(), false) as BlogPost
                    const imgPromises =
                        rawRes &&
                        rawRes.imageDeck &&
                        rawRes.imageDeck[0].image &&
                        rawRes.imageDeck[0].image.map((imgRef) => {
                            return imgRef
                                .get()
                                .then((snapshot) => {
                                    const data = snapshot.data()
                                    return data && data.file
                                })
                                .then((file) => storageRef.child(`flamelink/media/${file}`).getDownloadURL())
                                .then((url) =>
                                    imagekit.url({
                                        path: url.replace('https://firebasestorage.googleapis.com', ''),
                                    })
                                )
                        })
                    return Promise.all([
                        Promise.resolve(rawRes),
                        ...(imgPromises && imgPromises.length > 0 ? imgPromises : [this.getRandomCarouselImg()]), // get a random image if there is no
                    ])
                })

                return Promise.all(postPromises).then((rawResArr) =>
                    rawResArr.map(([rawRes, ...images]) => ({
                        ...rawRes,
                        content: '',
                        imageDeck: undefined,
                        deckImageURLs: images,
                    }))
                )
            })
            .then((res) => {
                this.newPosts = res
            })
    },
    methods: {
        getRandomCarouselImg() {
            return storageRef
                .child('carousel')
                .listAll()
                .then((listResult) => {
                    const randomInd = Math.floor(Math.random() * Math.floor(listResult.items.length))
                    return listResult.items[randomInd].getDownloadURL()
                })
                .then((url) =>
                    imagekit.url({
                        path: url.replace('https://firebasestorage.googleapis.com', ''),
                    })
                )
        },
    },
})
